function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useContext, useEffect, useReducer, useRef } from 'react';
import invariant from 'invariant';
import classnames from 'classnames';
import Step from '../step';
import { calcNamePath, getRuleValidation, calcShouldRender } from '../../utils/form-utils';
import FormContext from '../../form-context';
import StepContext from '../../form-step-context';
import { LocaleContext } from '../../locale';
import './style/index.less';

var Steps = function Steps(_ref) {
  var parentName = _ref.parentName,
      _ref$config = _ref.config,
      name = _ref$config.name,
      _ref$config$elements = _ref$config.elements,
      elements = _ref$config$elements === void 0 ? [] : _ref$config$elements,
      _ref$config$showLastI = _ref$config.showLastIndex,
      showLastIndex = _ref$config$showLastI === void 0 ? true : _ref$config$showLastI,
      _ref$config$currentSt = _ref$config.currentStep,
      currentStep = _ref$config$currentSt === void 0 ? 0 : _ref$config$currentSt,
      subscribedFields = _ref$config.subscribedFields,
      onEdit = _ref$config.onEdit,
      className = _ref$config.className;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      current = _useState2[0],
      setCurrent = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      last = _useState4[0],
      setLast = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      shouldScroll = _useState6[0],
      setShouldScroll = _useState6[1];

  var _useReducer = useReducer(function (r) {
    return r + 1;
  }, 0),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _ = _useReducer2[0],
      dispatch = _useReducer2[1];

  var sections = useRef(new Map());

  var _useContext = useContext(FormContext),
      form = _useContext.form,
      getRuleValidationApi = _useContext.getRuleValidationApi,
      registerDependencies = _useContext.registerDependencies;

  var _useContext2 = useContext(LocaleContext),
      currentLang = _useContext2.currentLang;

  useEffect(function () {
    var subscribe = elements.some(function (_ref2) {
      var shouldRender = _ref2.shouldRender,
          getButtonDisabledState = _ref2.getButtonDisabledState,
          shouldRenderCode = _ref2.shouldRenderCode;
      return Boolean(shouldRender) || Boolean(getButtonDisabledState) || Boolean(shouldRenderCode);
    });

    if (subscribe) {
      Array.isArray(subscribedFields) ? registerDependencies(subscribedFields, dispatch) : registerDependencies('SUBSCRIBE_ALL', dispatch);
    }

    var dependentField = [];
    elements.forEach(function (_ref3) {
      var asserts = _ref3.asserts;
      if (!(asserts === null || asserts === void 0 ? void 0 : asserts.length)) return;
      asserts.forEach(function (_ref4) {
        var field = _ref4.field;
        return dependentField.push(field);
      });
    });
    dependentField.length && registerDependencies(dependentField, dispatch);
  }, []);
  useEffect(function () {
    if (currentStep === undefined || currentStep === current) return;
    setCurrent(currentStep);
  }, [currentStep]);
  var renderElements = elements.filter(function (_ref5) {
    var curName = _ref5.name,
        dependencies = _ref5.dependencies,
        asserts = _ref5.asserts,
        shouldRender = _ref5.shouldRender,
        shouldRenderCode = _ref5.shouldRenderCode;
    return calcShouldRender(calcNamePath(calcNamePath(parentName, name), curName), dependencies, asserts, shouldRender, shouldRenderCode, form);
  });

  var handleNext = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _allFields$filter;

      var allFields, allValues, _renderElements$curre, currentName, handleNext, validationRule, namePath, fields, res, errors;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              allFields = (form === null || form === void 0 ? void 0 : form.getFieldsError()) || [];
              allValues = form === null || form === void 0 ? void 0 : form.getFieldsValue(true);
              _renderElements$curre = renderElements[current], currentName = _renderElements$curre.name, handleNext = _renderElements$curre.handleNext, validationRule = _renderElements$curre.validationRule;
              namePath = calcNamePath(name, currentName);
              fields = allFields === null || allFields === void 0 ? void 0 : (_allFields$filter = allFields.filter(function (_ref7) {
                var name = _ref7.name;
                return name.join().startsWith(namePath === null || namePath === void 0 ? void 0 : namePath.join());
              })) === null || _allFields$filter === void 0 ? void 0 : _allFields$filter.map(function (_ref8) {
                var name = _ref8.name;
                return name;
              });
              _context.prev = 5;
              _context.next = 8;
              return form === null || form === void 0 ? void 0 : form.validateFields(fields);

            case 8:
              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](5);
              form === null || form === void 0 ? void 0 : form.scrollToField(_context.t0.errorFields[0].name);
              return _context.abrupt("return");

            case 14:
              if (!(validationRule && getRuleValidationApi)) {
                _context.next = 28;
                break;
              }

              _context.prev = 15;
              _context.next = 18;
              return getRuleValidation(getRuleValidationApi, validationRule, allValues, currentLang);

            case 18:
              res = _context.sent;

              if (!(Array.isArray(res) && res.length)) {
                _context.next = 23;
                break;
              }

              form === null || form === void 0 ? void 0 : form.setFields(res);
              form === null || form === void 0 ? void 0 : form.scrollToField(res[0].name);
              return _context.abrupt("return");

            case 23:
              _context.next = 28;
              break;

            case 25:
              _context.prev = 25;
              _context.t1 = _context["catch"](15);
              return _context.abrupt("return");

            case 28:
              if (!(typeof handleNext === 'function')) {
                _context.next = 40;
                break;
              }

              _context.prev = 29;
              _context.next = 32;
              return handleNext(form === null || form === void 0 ? void 0 : form.getFieldsValue(fields));

            case 32:
              errors = _context.sent;

              if (!Array.isArray(errors)) {
                _context.next = 35;
                break;
              }

              return _context.abrupt("return", form === null || form === void 0 ? void 0 : form.setFields(errors));

            case 35:
              _context.next = 40;
              break;

            case 37:
              _context.prev = 37;
              _context.t2 = _context["catch"](29);
              return _context.abrupt("return");

            case 40:
              setCurrent(last || current + 1);
              setLast(0);
              setShouldScroll(true);

            case 43:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 10], [15, 25], [29, 37]]);
    }));

    return function handleNext() {
      return _ref6.apply(this, arguments);
    };
  }();

  var handleEdit = function handleEdit(index) {
    setLast(current);
    setCurrent(index);
    setShouldScroll(false);
    typeof onEdit === 'function' && onEdit(index);
  };

  var registerSection = function registerSection(name, toggle) {
    sections.current.set(name, toggle);
  };

  return _jsx("div", {
    className: classnames('igloo-steps-container', className),
    children: _jsx("div", {
      className: 'igloo-steps-content',
      children: renderElements.map(function (child, index) {
        invariant(child.type === 'Step', 'Child of steps should be Step');
        invariant(!child.validationRule || getRuleValidationApi, 'Please provide getRuleValidationApi in Form props');
        return _jsx(StepContext.Provider, {
          value: {
            registerSection: registerSection
          },
          children: _jsx(Step, {
            config: child,
            parentName: calcNamePath(parentName, name),
            index: index,
            total: renderElements.length,
            preview: current > index,
            edit: current === index,
            handleNext: handleNext,
            handleEdit: handleEdit,
            showLastIndex: showLastIndex,
            shouldScroll: shouldScroll
          }, child.key || child.name)
        });
      })
    })
  });
};

export default Steps;